import React from "react";

import * as styles from "./component.module.scss";
import clsx from "clsx";

import DotUnfilled from "../assets/dot_unfilled.svg";
import DotFilled from "../assets/dot_filled.svg";

const CarouselDotsTrack = ({
  size = 0,
  selectedIndex = -1,
  onDotClick,
}: {
  size?: number;
  selectedIndex?: number;
  onDotClick?: (index: number) => void;
}) => {
  const dots: React.ReactNode[] = [];

  for (let idx = 0; idx < size; idx++) {
    dots.push(
      <span
        className={clsx(
          styles.dotWrapper,
          selectedIndex === idx && styles.selected
        )}
        onClick={() => {
          if (typeof onDotClick !== "function") {
            return;
          }
          onDotClick(idx);
        }}
      >
        {selectedIndex === idx ? <DotFilled /> : <DotUnfilled />}
      </span>
    );
  }

  return <div className={styles.main}>{dots}</div>;
};

export default CarouselDotsTrack;
